export const onEventPage = async (locationPath: string, titlePage: string) => {
  await window.analytics?.page(locationPath, {
    title: titlePage,
  })
}
